import styled from "@emotion/styled";
import { css, keyframes } from "@emotion/react";
import { /*Select,*/ SelectChangeEvent } from "@mui/material";
import {
  ChangeEvent,
  FormEvent,
  useEffect,
  useRef,
  useState,
} from "react";
import { useLocation } from "react-router-dom";
import SelectBox from "../../components/selectBox";
import theme from "../../theme";
import { DetectTodayResult, GetMobilityLive } from "../../types/types";
import { deviceImageArray } from "../../utils/deviceImageArray";
import Spinner from "../../components/spinner";
import { DotLoader } from "../../components/dotLoader";
import {
  getEventOptions,
  getMobileOptions,
  LIMIT_OPTIONS,
} from "../../utils/constants";
import { getMobilityTypeText } from "../../utils/langUtils";
import { SearchForm } from "../../components/common/SearchForm";
import { CustomTooltip } from "../../components/common/CustomTooltip";
import {
  formatDate,
  handleKeyDown,
  textSubstring,
} from "../../utils/util";
import { useWindowSize } from "@reactuses/core";
import Calendars from "../../components/calendars";
import { CustomAlert } from "../../components/customAlert";
import { WarningIcon } from "../../assets/icons/icons";
import { SelectBoxGroupId } from "../../components/SelectBoxGroupId";
import { UtilBarTabButtons } from "../../components/UtilBarTabButtons";
import { useI18n } from "../../locales";

const { sm, md, lg } = theme.screen;

const UtilBarLeft: React.FC<{
  data?: GetMobilityLive[];
  allData?: GetMobilityLive[]; // 페이징 없는 전체 데이터
  mobFilter: number;
  setMobFilter: any;
  onClickBtn: any;
  onClickBtn2: any;
  selectedInfo?: GetMobilityLive | DetectTodayResult;
  leftFold: boolean;
  page: number;
  setPage: any;
  total_page: number | undefined;
  total_items: number | undefined;
  isLoading: any;
  activeRight?: boolean;
  setActiveRight?: any;
  listDataLimit?: number;
  setListDataLimit?: any;
  setEventCode: any;
  setStartDate: any;
  setEndDate: any;
  setGroupSubCode: any;
  handleClickDevice: (el: GetMobilityLive | null) => void;
  onClickStatBtn: any;
  runStat: any;
}> = (props) => {
  const {
    data,
    allData,
    mobFilter,
    setMobFilter,
    onClickBtn,
    onClickBtn2,
    selectedInfo,
    leftFold,
    setPage,
    total_items,
    isLoading,
    activeRight,
    setActiveRight,
    listDataLimit,
    setListDataLimit,
    handleClickDevice,
    setEventCode,
    setStartDate,
    setEndDate,
    setGroupSubCode,
    onClickStatBtn,
    //runStat,
  } = props;
  const { t } = useI18n();
  const { width } = useWindowSize();
  const location = useLocation();
  const [mobFilterOpen, setMobFilterOpen] = useState(false);
  const [input, setInput] = useState("");
  const [limitFilterOpen, setLimitFilterOpen] = useState(false);
  const selectedEl = useRef<HTMLDivElement>(null); // 선택된 리스트 포커스 이동
  const [filter, setFilter] = useState(0); // 감지종류
  const [filterOpen, setFilterOpen] = useState(false); // 감지종류
  const [start, setStart] = useState<Date | null>(null);
  const [end, setEnd] = useState<Date | null>(null);
  const [mobileWidth, setMobileWidth] = useState(0);
  const [groupSub, setGroupSub] = useState("all");
  const [openDateAlert, setOpenDateAlert] = useState(false);
  //const [openList, setOpenList] = useState(false); // 실시간 운행상황 기기 목록 모달 리스트
  const [runStatClick, setRunStatClick] = useState<
  "crash" | "warn" | "run" | "stop" | undefined
  >(undefined);
  

  useEffect(() => {
    setMobileWidth(width / 2 - 20);
  }, [width]);

  const mobHandleChange = (event: SelectChangeEvent) => {
    setMobFilter(Number(event.target.value));
  };

  const mobHandleClose = () => {
    setMobFilterOpen(false);
  };

  const mobHandleOpen = () => {
    setMobFilterOpen(true);
  };

  const limitHandleChange = (
    event: SelectChangeEvent<typeof listDataLimit>
  ) => {
    setListDataLimit(Number(event.target.value));
    setPage(0);
  };

  const limitHandleClose = () => {
    setLimitFilterOpen(false);
  };

  const limitHandleOpen = () => {
    setLimitFilterOpen(true);
  };

  const onChangeInput = (e: ChangeEvent<HTMLInputElement>) => {
    setInput(e.currentTarget.value);
  };
  const handleChange = (event: SelectChangeEvent<typeof filter>) => {
    setFilter(Number(event.target.value));
  };

  const handleClose = () => {
    setFilterOpen(false);
  };

  const handleOpen = () => {
    setFilterOpen(true);
  };

  // useEffect(() => {
  //   // 현재 페이지에 선택된 데이터 없으면 페이지 이동
  //   if (
  //     !data ||
  //     !allData ||
  //     !selectedInfo ||
  //     !listDataLimit ||
  //     width <= md
  //   )
  //     return;
  //   const targetIndex = allData.findIndex(
  //     (el) => el.seq === selectedInfo.seq
  //   );
  //   if (targetIndex > -1) {
  //     // 선택된 데이터 인덱스가 페이지 데이터 수보다 작음 (맨 앞 페이지임)
  //     if (targetIndex <= listDataLimit) {
  //       setPage(0);
  //     }
  //     // 선택된 데이터 인덱스가 페이지 데이터 수 보다 많음 (페이지 이동)
  //     else {
  //       const value = Math.ceil(targetIndex / listDataLimit);
  //       setPage(value - 1);
  //       selectedEl?.current?.scrollIntoView();
  //     }
  //   }
  // }, [data, allData, selectedInfo, listDataLimit]);
  useEffect(() => {
    // 현재 페이지에 선택된 데이터 없으면 페이지 이동
    if (
      !data ||
      !allData ||
      !selectedInfo ||
      !listDataLimit ||
      width <= md
    )
      return;
    const targetIndex = allData.findIndex(
      (el) => el.seq === selectedInfo.seq
    );

    if (targetIndex > -1) {
      // 선택된 데이터 인덱스가 페이지 데이터 수보다 작음 (맨 앞 페이지임)
      if (targetIndex < listDataLimit) {
        setPage(0);
      }
      // 선택된 데이터 인덱스가 페이지 데이터 수 보다 많음 (페이지 이동)
      else {
        const newPage = Math.floor(targetIndex / listDataLimit);
        setPage(newPage);
        selectedEl?.current?.scrollIntoView();
      }
    }
  }, [data, allData, selectedInfo, listDataLimit]);

  useEffect(() => {
    if (location.state) {
      if (location.state.selectedTab === "realTime") {
        setActiveRight(true);
        return;
      }
      if (location.state.selectedTab === "mobility") {
        setActiveRight(false);
        return;
      }
    }
  }, [location.state]);

  useEffect(() => {
    // 데이터 선택하면 스크롤 이동
    if (width > md && selectedEl && selectedEl.current) {
      selectedEl.current.scrollIntoView();
    }
  }, [selectedInfo, selectedEl, selectedEl.current]);

  // 조회 버튼 클릭
  const onClickSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if ((start && !end) || (end && !start)) {
      setOpenDateAlert(true);
      return;
    }

    onClickBtn(input);
    onClickBtn2(mobFilter);
    setPage(0);
    setStartDate(start);
    setEndDate(end);
    setEventCode(filter);
    setGroupSubCode(groupSub);
    //onClickStatBtn(runStatClick);
  };

  // 종류별 감지내역에서 이벤트 클릭
  const onClickStat = (rStat: "crash" | "warn" | "run" | "stop" ) => {
    if(runStatClick===rStat) {
      setRunStatClick(undefined);
    }else{
      setRunStatClick(rStat);
    }
    //setOpenList(true);
  };

  useEffect(() => {
    onClickStatBtn(runStatClick);
  }, [runStatClick]);

  // console.log(data);

  return (
    <Wrapper leftFold={leftFold}>
      {/* 좌측 상단 메뉴 버튼 */}
      <UtilBarTabButtons
        activeRight={activeRight}
        setActiveRight={setActiveRight}
      />

      <DivContainer activeRight={activeRight}>
        {/* 셀렉박스 */}
        <SelectWrapper>
          <SelectBox
            open={filterOpen}
            filter={filter}
            handleChange={handleChange}
            handleClose={handleClose}
            handleOpen={handleOpen}
            title={t.control.selectDetectionType}
            menuItems={getEventOptions(t)}
            width={width <= md ? mobileWidth : 180}
            // width={175}
            mr="0px"
            srLabel={t.control.selectDetectionType}
          />
          <SelectBox
            open={mobFilterOpen}
            filter={mobFilter}
            handleChange={mobHandleChange}
            handleClose={mobHandleClose}
            handleOpen={mobHandleOpen}
            title={t.control.selectDeviceType}
            menuItems={getMobileOptions(t)}
            width={width <= md ? mobileWidth : 180}
            // width={175}
            mr="0px"
            srLabel={t.control.selectDeviceType}
          />
        </SelectWrapper>

        {/* 기간 조회 */}
        <SelectWrapper2>
          <Calendars
            startDate={start}
            endDate={end}
            setStartDate={setStart}
            setEndDate={setEnd}
            isSeparate={false}
            width={width <= md ? mobileWidth : 180}
            isClearable
          />
        </SelectWrapper2>

        <SelectWrapper2>
          {/* 하위 그룹 조회 */}
          <SelectBoxGroupId
            groupSub={groupSub}
            setGroupSub={setGroupSub}
            width={width <= md ? mobileWidth : 180}
          />
          <div
            style={{
              width: width <= md ? mobileWidth : 180,
            }}
          ></div>
        </SelectWrapper2>

        {/* 검색바 */}
        <CustomForm>
          <SearchForm
            onSubmit={onClickSubmit/*(e: FormEvent<HTMLFormElement>) => {
              e.preventDefault();
              onClickBtn(input);
              onClickBtn2(mobFilter);
              setPage(0);
            }*/}
            placeholder={t.control.searchDeviceOwner}
            onChange={onChangeInput}
            inputValue={input}
            setInputValue={setInput}
            bottom="0"
            width="100%"
            direction="column"
            gap={width > md ? "20px" : "6px"}
          />
        </CustomForm>
        <Separator />
        {/* 실시간 운행상황 */}
        <SHeaderWrapper>
        <Header>
          {t.control.realtimeOperationStatus}
          {isLoading ? (
            <div style={{ display: "inline-block", paddingLeft: "10px" }}>
              <DotLoader />
            </div>
          ) : data?.length ? (
            <span>{` (${t.control.totalFarmMachinery} - ${
              (data[0]?.counts?.accident ?? 0) +
              (data[0]?.counts?.warning ?? 0) +
              (data[0]?.counts?.normal ?? 0) +
              (data[0]?.counts?.unoperated ?? 0)
            }${t.dashboard.unit})`}</span>
          ) : (
            <span>{` (${t.control.totalFarmMachinery} - 0${t.dashboard.unit})`}</span>
          )}
        </Header>
      </SHeaderWrapper>
      
      <MobStatusWrapper>
        <MobStatusCard
          bgColor={theme.color.pastelRed_500}
          selected={runStatClick==="crash"?true:false}
          onClick={() => onClickStat("crash")}
        >
          <MobStatusText
            selected={runStatClick==="crash"?true:false}
          >
            {t.control.danger}
             {/* <br/> ({t.control.rolloverAccident}) */}
          </MobStatusText>
          <MobStatusCount
          bgColor={theme.color.pastelRed_500}>
            {(allData && allData.length > 0) ? (allData[0]?.counts?.accident ?? 0) : 0}{/*t.dashboard.unit*/}
          </MobStatusCount>
        </MobStatusCard>
        <MobStatusCard
          bgColor={theme.color.pastelOrange_500}
          selected={runStatClick==="warn"?true:false}
          onClick={() => onClickStat("warn")}
        >
          <MobStatusText
            selected={runStatClick==="warn"?true:false}
          >{t.control.caution}</MobStatusText>
          <MobStatusCount
          bgColor={theme.color.pastelOrange_500}>
            {(allData && allData.length > 0) ? (allData[0]?.counts?.warning ?? 0) : 0}{/*t.dashboard.unit*/}
          </MobStatusCount>
        </MobStatusCard>
        <MobStatusCard
          bgColor={theme.color.pastelGreen_500}
          selected={runStatClick==="run"?true:false}
          onClick={() => onClickStat("run")}
        >
          <MobStatusText
            selected={runStatClick==="run"?true:false}
          >{t.control.operating}</MobStatusText>
          <MobStatusCount
          bgColor={theme.color.pastelGreen_500}>
            {(allData && allData.length > 0) ? (allData[0]?.counts?.normal ?? 0) : 0}{/*t.dashboard.unit*/}
          </MobStatusCount>
        </MobStatusCard>
        <MobStatusCard
          bgColor={theme.color.neutral_400}
          selected={runStatClick==="stop"?true:false}
          onClick={() => onClickStat("stop")}
        >
          <MobStatusText
            selected={runStatClick==="stop"?true:false}
          >{t.control.notOperating}</MobStatusText>
          <MobStatusCount
          bgColor={theme.color.neutral_400}>
            {(allData && allData.length > 0) ? (allData[0]?.counts?.unoperated ?? 0) : 0}{/*t.dashboard.unit*/}
          </MobStatusCount>
        </MobStatusCard>
      </MobStatusWrapper>
      <Separator />

      {/* 조회된 결과 */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <MobCountText>
            {t.control.searchedFarmMachinery} -
            {isLoading ? (
              <div
                style={{ display: "inline-block", paddingLeft: "10px" }}
              >
                <DotLoader />
              </div>
            ) : total_items ? (
              <span>{` ${total_items}${t.dashboard.unit}`}</span>
            ) : (
              <span>{` 0${t.dashboard.unit}`}</span>
            )}
          </MobCountText>
          {/* 셀렉박스 */}
          <SelectWrapper>
            <SelectBox
              open={limitFilterOpen}
              filter={listDataLimit}
              filterWord={t.common.casesUnit}
              handleChange={limitHandleChange}
              handleClose={limitHandleClose}
              handleOpen={limitHandleOpen}
              title={t.control.resultsPerPage}
              menuItems={LIMIT_OPTIONS}
              width={120}
              srLabel={t.control.resultsPerPage}
            />
          </SelectWrapper>
        </div>

        <List>
          {isLoading && <Spinner />}
          {data &&
            data?.map((el) => {
              const isLeased = !!el.lease_name; // 임차인 존재하는지 여부
              return (
                <ListItem
                  ref={
                    el.device_pid === selectedInfo?.device_pid
                      ? selectedEl
                      : null
                  }
                  active={
                    el.device_pid === selectedInfo?.device_pid && true
                  }
                  hoverColor={
                    el.status === "미운행" || !el.status
                      ? theme.color.neutral_100
                      : el.events?.includes("차량전복")
                      ? theme.color.red_100
                      : el.events === null
                      ? theme.color.green_100
                      : theme.color.orange_100
                  }
                  accentColor={
                    el.status === "미운행" || !el.status
                      ? theme.color.neutral_500
                      : el.events?.includes("차량전복")
                      ? theme.color.red_500
                      : el.events === null
                      ? theme.color.green_500
                      : theme.color.orange_500
                  }
                  key={el.seq.toString()}
                  onClick={() => {
                    handleClickDevice(el);
                  }}
                  role="button"
                  tabIndex={0}
                  onKeyDown={handleKeyDown}
                >
                  <div>
                    <ImageWrapper
                      bgColor={
                        el.status === "미운행" || !el.status
                          ? theme.color.neutral_100
                          : el.status === "운행중" &&
                            el.event_accident !== "정상"
                          ? theme.color.red_100
                          : el.status === "운행중" &&
                            el.event_accident === "정상" &&
                            el.events !== null
                          ? theme.color.orange_100
                          : theme.color.green_100
                      }
                      bdColor={
                        el.status === "미운행" || !el.status
                          ? "rgba(26, 39, 35, 0.5)"
                          : el.status === "운행중" &&
                            el.event_accident !== "정상"
                          ? "rgba(245, 80, 78, 0.5)"
                          : el.status === "운행중" &&
                            el.event_accident === "정상" &&
                            el.events !== null
                          ? "rgba(255, 119, 43, 0.5)"
                          : "rgba(92, 200, 109, 0.5)"
                      }
                    >
                      {el?.mobility_image === null ? (
                        <CustomImg
                          src={`${process.env.REACT_APP_BASE_URL}/img/${
                            deviceImageArray.find(
                              (list) => list.device === el.mobility_type
                            )?.listFileName
                          }`}
                          alt="농기계 이미지"
                        />
                      ) : (
                        <CustomImg
                          src={`${process.env.REACT_APP_BASE_URL}/${el?.mobility_image}`}
                          alt="농기계 이미지"
                          isEtc
                        />
                      )}
                    </ImageWrapper>
                  </div>
                  <InfoWrapper>
                    <CustomTooltip
                      title={el?.mobility_name}
                      active={el?.mobility_name?.length > 15}
                    >
                      <First>
                        {el.mobility_name != null
                          ? el.mobility_name.length > 15
                            ? el.mobility_name.substring(
                                0,
                                15 - getMobilityTypeText(el.mobility_type, t).length
                              ) + "..."
                            : el.mobility_name
                          : ""}
                        [{getMobilityTypeText(el.mobility_type, t)}]
                      </First>
                    </CustomTooltip>

                    <CustomTooltip
                      title={el?.name}
                      active={el?.name?.length > 14}
                    >
                      {/* <Second>
                        소유자 : {textSubstring(el.name, 0, 14)}
                      </Second> */}
                      <Second>
                        {t.control.owner} :{" "}
                        {textSubstring(
                          isLeased ? el.lease_name : el.name,
                          0,
                          14
                        )}
                      </Second>
                    </CustomTooltip>

                    <Third>
                      {t.control.lastOperation} :
                      {!el.max_registered_at && !el.min_registered_at
                        ? ` ${t.control.noRecord}`
                        : !el.max_registered_at
                        ? formatDate(
                            el.min_registered_at,
                            "yyyy-MM-dd HH:mm:ss"
                          )
                        : formatDate(
                            el.max_registered_at,
                            "yyyy-MM-dd HH:mm:ss"
                          )}
                    </Third>
                  </InfoWrapper>
                </ListItem>
              );
            })}
          {!isLoading && (!data || data?.length === 0) && (
            <NoDataMassage>{t.common.noData}.</NoDataMassage>
          )}
        </List>
      </DivContainer>

      {/* 시작일 또는 종료일 누락시 경고 얼럿 */}
      <CustomAlert
        open={openDateAlert}
        onPressOK={() => setOpenDateAlert(false)}
        title={t.control.checkDate}
        content={t.control.selectBothDates}
        confirmText={t.common.confirm}
        icon={<WarningIcon />}
      />
    </Wrapper>
  );
};

const utilBarLeftClose = keyframes`
from{
  left:0px;
}
to{
  left:-420px;
}
`;

const utilBarLeftOpen = keyframes`
from{
  left:-420px;
}
to{
  left:0px;
}
`;

const Wrapper = styled.div<{ leftFold: boolean }>`
  background-color: ${theme.color.neutral_50};
  box-shadow: 6px 4px 10px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;

  @media (max-width: ${md}px) {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0px;
    z-index: ${theme.zindex.controlListMd};
    box-shadow: none;
  }

  @media (min-width: ${md + 1}px) and (max-width: ${lg}px) {
    width: 420px;
    position: absolute;
    left: 0px;
    /* height: 100vh; */
    height: calc(100vh - 62px - 76px);
    overflow-y: auto;
    overflow-x: hidden;
    ${({ leftFold }) =>
      leftFold
        ? css`
            animation: ${utilBarLeftClose} 0.5s ease;
          `
        : !leftFold
        ? css`
            animation: ${utilBarLeftOpen} 0.5s ease;
          `
        : null}
    animation-fill-mode:both;
  }

  @media (min-width: ${lg + 1}px) {
    width: 420px;
    position: absolute;
    left: 0px;
    /* height: 100vh; */
    height: calc(100vh - 62px - 76px);
    overflow-y: auto;
    overflow-x: hidden;
    ${({ leftFold }) =>
      leftFold
        ? css`
            animation: ${utilBarLeftClose} 0.5s ease;
          `
        : !leftFold
        ? css`
            animation: ${utilBarLeftOpen} 0.5s ease;
          `
        : null}
    animation-fill-mode:both;
  }
`;

const DivContainer = styled.div<{ activeRight?: boolean }>`
  padding-top: 20px;
  height: 100%;
  display: flex;
  flex-direction: column;
  @media (max-width: ${md}px) {
  }
  @media (min-width: ${md + 1}px) and (max-width: ${lg}px) {
    overflow-y: auto;
    overflow-x: hidden;
  }
`;

const SelectWrapper = styled.div`
  background-color: ${theme.color.neutral_50};
  padding: 10px 20px;
  display: flex;
  gap: 15px;

  @media (max-width: ${md}px) {
    padding: 13px 10px 6px 10px;
    justify-content: center;
    align-items: center;
    gap: 15px;
  }
`;

const SelectWrapper2 = styled(SelectWrapper)`
  background-color: ${theme.color.neutral_50};
  display: flex;
  gap: 15px;

  @media (max-width: ${md}px) {
    padding: 5px 10px;
    justify-content: center;
    align-items: center;
  }

  @media (min-width: ${md + 1}px) {
    padding-top: 0px;
  }
`;

const CustomForm = styled.div`
  padding: 0px 20px;
  position: relative;
  margin-bottom: 25px;
  width: 100%;
  @media (max-width: ${md}px) {
    padding: 10px 6px 25px 10px;
  }
`;

const MobCountText = styled.strong`
  display: block;
  font-weight: 700;
  font-size: 18px;
  line-height: 21px;
  color: ${theme.color.neutral_700};
  margin-left: 20px;
  margin-bottom: 24px;

  @media (max-width: ${md}px) {
    margin-left: 10px;
    margin-bottom: 0px;
    font-size: ${theme.fontSize.FONT_1};
    font-weight: ${theme.fontWeight.SEMI_BOLD};
  }
`;

const Separator = styled.div`
  border-bottom: 2px solid ${theme.color.neutral_200};
`;

const List = styled.div`
  flex: 1;
`;

export const ListItem = styled.div<{
  active?: boolean;
  accentColor?: string;
  hoverColor?: string;
}>`
  display: flex;
  gap: 20px;
  padding: 22px 20px;
  border-bottom: 1px solid ${theme.color.neutral_200};
  background-color: ${({ active, hoverColor }) =>
    active ? hoverColor : theme.color.white};
  cursor: pointer;
  &:hover {
    background-color: ${({ hoverColor }) => hoverColor};
  }
  border-left: ${({ active, accentColor }) =>
    active ? `5px solid ${accentColor}` : "none"};
  order: ${({ active }) => active && "-1"};
  position: relative;

  @media (max-width: ${sm}px) {
    gap: 15px;
    padding: 22px 20px;
  }
`;

const CustomImg = styled.img<{ isEtc?: boolean }>`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: ${({ isEtc }) => (isEtc ? `fill` : `contain`)};
`;

export const ImageWrapper = styled.div<{
  bgColor: string;
  bdColor: string;
}>`
  background-color: ${({ bgColor }) => bgColor};
  width: 65px;
  height: 61px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  border: ${({ bdColor }) => `3px solid ${bdColor}`};
  flex-shrink: 0;
`;

export const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const First = styled.span`
  font-weight: 700;
  font-size: 16px;
  line-height: 19px;
  color: ${theme.color.neutral_700};
  @media (max-width: ${sm}px) {
    font-size: 15px;
  }
`;

export const Second = styled.span`
  font-weight: 700;
  color: ${theme.color.neutral_700};
  font-size: 14px;
  line-height: 16px;
  @media (max-width: ${sm}px) {
    font-size: 13px;
  }
`;

export const Third = styled.span`
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;
  color: ${theme.color.neutral_500};
`;

const NoDataMassage = styled.div`
  text-align: center;
  padding: 50px;
  color: ${theme.color.neutral_500};
`;

const Header = styled.strong<{ responsive?: boolean }>`
  display: block;
  padding-top: 15px;
  padding-left: 25px;
  font-weight: 700;
  font-size: 18px;
  //line-height: 21px;
  color: ${theme.color.neutral_700};
  //margin-bottom: 25px;

  @media (min-width: ${md + 1}px) and (max-width: ${lg}px) {
    //display: ${({ responsive }) => !responsive && "none"};
  }
  @media (max-width: ${md}px) {
    padding: 0px;
    margin: 0px;
    font-size: ${theme.fontSize.FONT_1};
    font-weight: ${theme.fontWeight.SEMI_BOLD};
  }
`;

const SHeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  //padding-top: 19px;
  @media (max-width: ${md}px) {
    align-items: center;
    padding: 10px;
  }
`;

const MobStatusWrapper = styled.div`
  padding: 15px;
  display: flex;
  flex-direction: row;
  gap: 12px;
  justify-content: center;
`;

const MobStatusCard = styled.div<{ bgColor: string, selected: boolean }>`
  height: 100px;
  background: ${({ bgColor }) => bgColor};
  border-radius: 16px;
  display: flex;
  align-items: center;
  padding-left: 10px;
  padding-right: 10px;
  flex-direction: column;
  justify-content: space-between;
  padding-bottom: 10px;
  border: ${({ selected }) => selected && "3px solid"};
  box-shadow: ${({ selected }) => selected &&"0px 4px 4px 0px #00000040"};

  cursor: pointer;
  transition: 200ms;

  :hover {
    opacity: 0.8;
  }
`;

const MobStatusText = styled.span<{ selected: boolean }>`
  font-weight: 700;
  font-size: 13px;
  line-height: 20px;
  height: 45px;
  text-align: center;
  display: flex;
  align-items: center;
  color: ${theme.color.white};
  `;
  //color: ${({ selected }) => selected?theme.color.black:theme.color.white};

const MobStatusCount = styled.span<{ bgColor: string }>`
  font-weight: 700;
  font-size: 15px;
  line-height: 20px;
  color: ${({ bgColor }) => bgColor};
  background: ${theme.color.white};
  border-radius: 10px;
  width: 67px;
  height: 40px;
  display: flex;
  align-content: center;
  flex-wrap: wrap;
  justify-content: center;
`;

export default UtilBarLeft;
